import { OrganizationSettings } from '@care-portals/api-interfaces';
import { CRM_WEB_PAGES_URLS } from '../../CRM_WEB_PAGES_URLS';
import { ADMIN_WEB_PAGES_URLS } from '../../EMR_WEB_PAGES_URLS';
import { PATIENT_WEB_PAGES_URLS } from '../../PATIENT_WEB_PAGES_URLS';
import { usStates } from '../../data';

const coveredStates = [
  ...usStates.filter(s => !['LA', 'MS', 'NM', 'AL', 'OTHER'].includes(s.code))
];

export const jackjill_health: OrganizationSettings = {
  name: 'Jack and Jill Health',
  isJjc: true,
  fromEmail: 'hello@jackjill.health',
  replyToEmail: 'no-reply@jackjill.health',
  inboxMessageTemplateId: '64960bcb0b53bd50c7788439',
  forgotPasswordTemplateId: '64960c9c0b53bd50c7788441',
  verifyAccountTemplateId: '64961091d1af2a8473e1ee66',
  newAdminPasswordTemplateId: '649607ad4672309e6e2e23c1',
  ecommerceEnabled: false,
  stripeEnabled: true,
  blockCreateOrderOnFailedPayment: true,
  patientPortalDomain: 'app.jackjill.health',
  pharmacyEmail: 'pharmacy@jackjill.health',
  customerServiceEmail: 'help@jackjill.health',
  noMarketingListId: 'W7wvK2',
  bigcommerceCustomerGroupId: 0,
  conversationServiceId: 'IS4baec316c27d4643b9460d481449f745',
  adminCustomDomain: 'emr.jack.health',
  mainStripeOrg: 'jack_health',
  currency: 'usd',
  appointmentconsentSection: `
    <p style="text-align: center;color: #536476;">
    By clicking on {{cta_label}} you agree to our:<br />
    <a
      href="javascript:window.open('https://jackjill.health/privacy-policy', 'popup', 'width=600,height=600');"
    >
        Privacy Policies
    </a>
    <br>
    <a
      href="javascript:window.open('https://jackjill.health/terms-conditions', 'popup', 'width=600,height=600');"
    >
    Terms & Conditions
    </a>
      </p>
    `,

  // navigation
  crmWebAppLayout: {
    title: 'JJ Health US',
    icon: 'https://uploads-ssl.webflow.com/630cf5c3fde88d3fa5008ecc/64e7b9731cbba7aa224776ed_icon-jack.svg?ssl=1',
    logo: 'https://blog.jackjill.health/wp-content/uploads/Group-626891.svg',
    locations: [...usStates.map(s => ({ label: s.province, value: s.code }))],
    mainMenu: [
      {
        title: 'Leads',
        link: CRM_WEB_PAGES_URLS.leads.list,
        icon: 'fa-regular fa-address-book',
        roles: ['*']
      },
      {
        title: 'Order Stats',
        link: CRM_WEB_PAGES_URLS.orderStats.list,
        icon: 'fa-solid fa-chart-line',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: CRM_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fa-regular fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: CRM_WEB_PAGES_URLS.tasks.list,
        icon: 'fa-solid fa-list-check',
        roles: ['*']
      },
      {
        title: 'Segments',
        link: CRM_WEB_PAGES_URLS.segment.list,
        icon: 'fa-solid fa-table-columns',
        roles: ['*']
      },
      {
        title: 'Store Manager',
        link: '',
        icon: 'fas fa-shop',
        roles: ['admin', 'developer', 'owner', 'marketing'],
        items: [
          {
            title: 'Products',
            link: CRM_WEB_PAGES_URLS.products.list,
            icon: 'fas fa-product'
          },
          {
            title: 'Categories',
            link: CRM_WEB_PAGES_URLS.productCategories.list,
            icon: 'fas fa-list'
          },
          {
            title: 'Coupons',
            link: CRM_WEB_PAGES_URLS.coupons.list,
            icon: 'fas fa-gift'
          },
          {
            title: 'Promotions',
            link: CRM_WEB_PAGES_URLS.promotions.list,
            icon: 'fas fa-gift'
          }
        ]
      },
      {
        title: 'Admin',
        link: '',
        icon: 'fas fa-user-cog',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Services',
            link: CRM_WEB_PAGES_URLS.services.list,
            icon: 'fas fa-medkit'
          },
          {
            title: 'Schedules',
            link: CRM_WEB_PAGES_URLS.schedules.list,
            icon: 'fas fa-calendar'
          },
          {
            title: 'Users',
            link: CRM_WEB_PAGES_URLS.users.list,
            icon: 'fas fa-lock'
          },
          {
            title: 'Layouts',
            link: CRM_WEB_PAGES_URLS.layouts.list,
            icon: 'fas fa-columns'
          },
          {
            title: 'Schemas',
            link: CRM_WEB_PAGES_URLS.crmSchemas.list,
            icon: 'fas fa-receipt'
          },
          {
            title: 'Forms',
            link: CRM_WEB_PAGES_URLS.forms.list,
            icon: 'fas fa-table'
          },
          {
            title: 'Workflows',
            link: CRM_WEB_PAGES_URLS.workflows.list,
            icon: 'fas fa-code-branch'
          },
          {
            title: 'Templates',
            link: CRM_WEB_PAGES_URLS.emailTemplates.list,
            icon: 'fas fa-palette'
          },
          {
            title: 'Settings',
            link: CRM_WEB_PAGES_URLS.settings.base,
            icon: 'fa-solid fa-sliders'
          }
        ]
      }
    ]
  },
  emrWebAppLayout: {
    title: 'JJ Health US',
    defaultPingMsg:
      '🛎️ Ping! Jack & Jill Health care team is waiting for your response. To respond, please go to https://my.jackjill.health/messages',
    questionnaires: [
      'facesheet',
      'facesheet_ext',
      'govId',
      'selfie',
      'bodySelfie',
      'wlus',
      'wlusmonthly',
      'edBeluga',
      'edBelugaMonthly',
      'menHairLoss',
      'womenHairLoss',
      'hairLossFollowup',
      'unisexHairLoss'
    ],
    mainMenu: [
      {
        title: 'Patients',
        name: 'patients',
        link: ADMIN_WEB_PAGES_URLS.customers.allList,
        icon: 'fas fa-user-injured',
        roles: ['*']
      },
      {
        title: 'Consultations',
        name: 'consultations',
        link: ADMIN_WEB_PAGES_URLS.consultations.onlineList,
        icon: 'fas fa-user-md',
        roles: ['*']
      },
      {
        title: 'RX Transfers',
        name: 'rx-transfers',
        link: ADMIN_WEB_PAGES_URLS.consultations.generalList,
        icon: 'fas fa-file-prescription',
        roles: ['pharmacy', 'admin', 'owner']
      },
      {
        title: 'Orders',
        name: 'orders',
        link: ADMIN_WEB_PAGES_URLS.orders.allList,
        icon: 'fas fa-shopping-cart',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: ADMIN_WEB_PAGES_URLS.tasks.list,
        icon: 'fas fa-list-check',
        roles: ['*']
      },
      {
        title: 'Orders Kanban',
        name: 'orders-kanban',
        link: ADMIN_WEB_PAGES_URLS.orders.kanban,
        icon: 'fas fa-cart-plus',
        roles: ['*']
      },
      {
        title: 'Subscriptions',
        name: 'subscriptions',
        link: ADMIN_WEB_PAGES_URLS.subscriptions.allList,
        icon: 'fas fa-bars',
        roles: ['*']
      },
      {
        title: 'Drugs',
        link: ADMIN_WEB_PAGES_URLS.drugs.allList,
        icon: 'fas fa-pills',
        roles: ['*']
      },
      {
        title: 'RXs',
        name: 'rxs',
        link: ADMIN_WEB_PAGES_URLS.prescriptions.allList,
        icon: 'fas fa-prescription',
        roles: ['pharmacy', 'admin', 'owner']
      }
    ]
  },
  patientWebAppLayout: {
    title: 'Jack & Jill Health',
    brand: 'jackjill-health',
    theme: 'jackjill',
    colors: {
      primaryColor: '#000000'
    },
    shopUrl: 'https://jackjill.health',
    gtm: {
      id: 'GTM-5DWHBR4F',
      url: 'https://gtm.jackjill.health/gtm.js'
    },
    topAction: {
      title: 'Shop',
      link: 'https://jackjill.health'
    },
    logo: {
      img: 'https://blog.jackjill.health/wp-content/uploads/Group-626891.svg',
      link: '/home'
    },
    referrals: {
      enabled: true,
      referrerAmount: 50,
      refereeAmount: 30,
      referralURI: 'https://my.jackjill.health/auth/signup',
      referralFAQ: 'https://jackjill.health/referral-offer'
    },
    privacyPolicyUrl: 'https://jackjill.health/privacy-policy',
    termsOfUseUrl: 'https://jackjill.health/terms-of-use',
    stripePublicKey: 'pk_live_xgW4U7GvVtnOACnuHkaTQ6jF007oxkvEUs',
    availableStates: {
      us: coveredStates
    },
    mainMenu: [
      {
        title: 'Treatments',
        link: 'https://app.jackjill.health/treatments',
        target: '_self',
        svg: 'assets/icons/orders.svg',
        type: 'external',
        roles: ['*']
      },
      {
        title: 'Consultations',
        link: PATIENT_WEB_PAGES_URLS.account.consultations,
        svg: 'assets/icons/consultations.svg',
        roles: ['*']
      },
      {
        title: 'Prescriptions',
        link: PATIENT_WEB_PAGES_URLS.account.prescriptions,
        svg: 'assets/icons/rxs.svg',
        roles: ['*']
      },
      {
        title: 'Medical Inbox',
        link: PATIENT_WEB_PAGES_URLS.messages.inbox,
        svg: 'assets/icons/medical-chat.svg',
        roles: ['*']
      },
      {
        title: 'Subscriptions',
        link: PATIENT_WEB_PAGES_URLS.subscriptions.list,
        svg: 'assets/icons/orders.svg',
        roles: ['*']
      },
      {
        title: 'Billing',
        link: 'billing',
        svg: 'assets/icons/billing.svg',
        type: 'external',
        roles: ['*']
      },
      {
        title: 'Orders',
        link: PATIENT_WEB_PAGES_URLS.account.orders,
        svg: 'assets/icons/orders.svg',
        roles: ['*']
      },
      {
        title: 'Shop',
        link: 'shop',
        svg: 'assets/icons/shop.svg',
        type: 'external',
        roles: ['*']
      }
    ],
    productPlaceholderImage:
      'https://public.jackjill.health/uploads/jackjill_health/products/jackjill_health-product-fallback.png',
    enableResubmitOnIdVerification: true,
    isSelfieRequiredForVerification: true
  },

  pharmacies: {
    ValiantRx: {
      _id: '65e1eb938cd6e41498619ba3',
      belugaId: '269786',
      states: [
        'MA',
        'NM',
        'ND',
        'NJ',
        'WI',
        'AZ',
        'CO',
        'DE',
        'FL',
        'MN',
        'NY',
        'PA',
        'RI',
        'SD',
        'IN'
      ]
    },
    Belmar: {
      _id: '65e1ebc08cd6e41498619ba9',
      belugaId: '65012',
      states: [
        'CA',
        'GA',
        'ID',
        'IL',
        'IA',
        'MA',
        'NE',
        'NH',
        'NM',
        'ND',
        'OH',
        'WA',
        'MD',
        'NV',
        'NJ',
        'WI',
        'AZ',
        'CO',
        'CT',
        'DE',
        'DC',
        'FL',
        'KS',
        'LA',
        'ME',
        'MN',
        'MS',
        'MO',
        'MT',
        'NY',
        'OK',
        'OR',
        'PA',
        'RI',
        'SD',
        'TN',
        'TX',
        'UT',
        'WV',
        'WY',
        'AL',
        'AK',
        'AR',
        'IN',
        'KY',
        'MI',
        'SC',
        'VT',
        'VA'
      ]
    },
    Precision: {
      _id: '65e967269d89c1317c2aa621',
      belugaId: '265585',
      states: [
        //     'CA',
        //     'GA',
        //     'ID',
        //     'IL',
        //     'IA',
        //     'MA',
        //     'NE',
        //     'NH',
        //     'NM',
        //     'OH',
        //     'WA',
        //     'MD',
        //     'NV',
        //     'NJ',
        //     'WI',
        //     'AZ',
        //     'CO',
        //     'CT',
        //     'DE',
        //     'DC',
        //     'FL',
        //     'KS',
        //     'LA',
        //     'ME',
        //     'MN',
        //     'MS',
        //     'MO',
        //     'MT',
        //     'NY',
        //     'OK',
        //     'OR',
        //     'PA',
        //     'RI',
        //     'SD',
        //     'TN',
        //     'TX',
        //     'UT',
        //     'WV',
        //     'WY',
        //     'AL',
        //     'AK',
        //     'AR',
        //     'IN',
        //     'KY',
        //     'MI',
        //     'VT',
        //     'VA'
      ]
    },
    Curexa: {
      _id: '65e1ed1d8cd6e41498619bc4',
      belugaId: '29992',
      states: [
        'CA',
        'GA',
        'ID',
        'IL',
        'IA',
        'MA',
        'NE',
        'NH',
        'NM',
        'ND',
        'OH',
        'WA',
        'MD',
        'NV',
        'NJ',
        'NC',
        'WI',
        'AZ',
        'CO',
        'CT',
        'DE',
        'DC',
        'FL',
        'KS',
        'LA',
        'ME',
        'MN',
        'MS',
        'MO',
        'MT',
        'NY',
        'OK',
        'OR',
        'PA',
        'RI',
        'SD',
        'TN',
        'TX',
        'UT',
        'WV',
        'WY',
        'AL',
        'AK',
        'AR',
        'IN',
        'KY',
        'MI',
        'SC',
        'VT',
        'VA'
      ]
    },
    SouthEnd: {
      _id: '65e1ebd48cd6e41498619bac',
      belugaId: '239252',
      states: [
        'AK',
        'AZ',
        'CO',
        'CT',
        'DE',
        'DC',
        'FL',
        'HI',
        'IL',
        'IN',
        'IA',
        'ID',
        'KS',
        'KY',
        'LA',
        'ME',
        'MI',
        'MN',
        'MS',
        'MO',
        'MT',
        'ND',
        'NH',
        'NM',
        'NY',
        'OH',
        'OK',
        'OR',
        'PA',
        'RI',
        'SD',
        'TN',
        'TX',
        'UT',
        'WV',
        'WI',
        'WY',
        'WA',
        'VA',
        'VT'
      ]
    },
    Strive: {
      _id: '65e967439d89c1317c2aa622',
      belugaId: '255546',
      states: [
        'CA',
        'GA',
        'ID',
        'IL',
        'IA',
        'MA',
        'NE',
        'NH',
        'NM',
        'ND',
        'OH',
        'WA',
        'AZ',
        'CO',
        'DE',
        'DC',
        'FL',
        'KS',
        'MS',
        'MO',
        'MT',
        'NY',
        'OK',
        'OR',
        'PA',
        'RI',
        'SD',
        'TX',
        'UT',
        'WY',
        'PR'
      ]
    },
    RxCompoundStore: {
      _id: '65e967599d89c1317c2aa623',
      belugaId: '255863',
      states: [
        'AZ',
        'CO',
        'DE',
        'FL',
        'GA',
        'IL',
        'IN',
        'ME',
        'MD',
        'MA',
        'MN',
        'MO',
        'NJ',
        'NY',
        'NC',
        'OH',
        'PA',
        'RI',
        'UT',
        'WI'
      ]
    },
    TownAndCountry: {
      _id: '65e9676c9d89c1317c2aa624',
      belugaId: '244021',
      states: [
        'GA',
        'MA',
        'OH',
        'MD',
        'NJ',
        'AZ',
        'CO',
        'CT',
        'DE',
        'FL',
        'MN',
        'MO',
        'NY',
        'OK',
        'PA',
        'RI',
        'KY'
      ]
    },
    WellsRx: {
      _id: '65e9677d9d89c1317c2aa625',
      belugaId: '73382',
      states: [
        'GA',
        'ID',
        'IL',
        'IA',
        'MA',
        'NE',
        'NH',
        'NM',
        'ND',
        'OH',
        'MD',
        'NV',
        'NJ',
        'NC',
        'WI',
        'CO',
        'CT',
        'DE',
        'FL',
        'KS',
        'LA',
        'ME',
        'MN',
        'MS',
        'MO',
        'MT',
        'NY',
        'OK',
        'OR',
        'PA',
        'RI',
        'SD',
        'TN',
        'TX',
        'UT',
        // 'WA',
        'WV',
        'WY',
        'AL',
        'AK',
        'IN',
        'KY',
        'MI',
        'SC',
        'VT',
        'VA'
      ]
    },
    GogoMed: {
      _id: '65e1ebad8cd6e41498619ba6',
      belugaId: '245312',
      states: []
    },
    WPlabs: {
      _id: '66ab2e997b1e3950990a31f3',
      belugaId: '260574',
      states: [
        'AR'
        //'WA'
      ]
    }
  }
};
